export default __webpack_public_path__ + "static/media/Graphik-Regular.fb0cb273.woff";